/**
 * Home Hero
 * Animate the messages in the hero
 * Add .is-visible class to Bootstrap collapse elements when they are shown.
 */

export function homeHero() {
  const messagesContainer = document.querySelector("#home-hero .messages");
  if (!messagesContainer) {
    return;
  }

  const heroMessages = Array.from(
    messagesContainer.querySelectorAll(".message"),
  );

  if (heroMessages.length <= 1) {
    if (heroMessages.length === 1) {
      // Set height for single message and stop
      messagesContainer.style.height = `${heroMessages[0].scrollHeight}px`;
    }
    return;
  }

  const animationDuration = 500; // 0.5s
  const viewTime = 3500; // 2s

  let currentIndex = heroMessages.findIndex((msg) =>
    msg.classList.contains("is-visible"),
  );

  if (currentIndex === -1) {
    currentIndex = 0;
    heroMessages[0].classList.add("is-visible");
  }

  const setContainerHeight = () => {
    const visibleMessage = heroMessages[currentIndex];
    if (visibleMessage) {
      messagesContainer.style.height = `${visibleMessage.scrollHeight}px`;
    }
  };

  // Set initial height and on resize
  setContainerHeight();
  window.addEventListener("resize", setContainerHeight);

  const cycleMessages = () => {
    heroMessages[currentIndex].classList.remove("is-visible");
    currentIndex = (currentIndex + 1) % heroMessages.length;
    messagesContainer.style.height = `${heroMessages[currentIndex].scrollHeight}px`;
    heroMessages[currentIndex].classList.add("is-visible");
  };

  setInterval(cycleMessages, viewTime + animationDuration);
}
